import {inject, Pipe, PipeTransform} from '@angular/core';
import {formatAppNumber} from '@frontend/shared';
import {TranslocoService} from '@jsverse/transloco';
import {MetricValue} from './rfi-individual-results-modal.types';

@Pipe({
  name: 'rfiMetricValue',
})
export class RfiMetricValuePipe implements PipeTransform {
  private readonly translocoService = inject(TranslocoService);

  transform(value: MetricValue): string | null {
    if (value.amount === null) {
      return null;
    }
    if (typeof value.amount === 'boolean') {
      return this.translocoService.translate(value.amount ? 'common.yes' : 'common.no');
    }
    const digits = `1.0-${value.maxFractionDigits ?? 0}`;
    const formatted = formatAppNumber(value.amount, this.translocoService.getActiveLang(), digits);
    switch (value.format) {
      case 'percent':
        return `${formatted} %`;
      case 'signedPercent':
        return value.amount < 0 ? `${formatted} %` : `+${formatted} %`;
      default:
        return formatted;
    }
  }
}
